import React from 'react';
import TaxbillEditContainer from '../../containers/taxbillmng/TaxbillEditContainer';

const TaxbillEditPage = () => {
  return <TaxbillEditContainer/>
};

export default TaxbillEditPage;
